import gql from 'graphql-tag';
import { ResourceStatisticsFragments } from './resource-statistics.fragment';
import { ResourceFragments } from './resource.fragments';

export class ResourceQueries {
  static loadResourceQuery = gql`
    query LoadResource($id: String!) {
      resource(id: $id) {
        ...resourceDetailsFragment
        statistics {
          ...resourceStatisticsFragment
        }
      }
    }
    ${ResourceFragments.detailsFragment}
    ${ResourceStatisticsFragments.detailsFragment}
  `;

  static loadResourcesQuery = gql`
    query LoadResources(
      $directory: String
      $resourceType: ResourceType
      $searchTerms: [String!]!
      $limit: Int!
      $offset: Int!
      $sortBy: ResourceSortAttributes!
      $sortOrder: String!
    ) {
      resources(
        directory: $directory
        resourceType: $resourceType
        searchTerms: $searchTerms
        limit: $limit
        offset: $offset
        sortBy: $sortBy
        sortOrder: $sortOrder
      ) {
        resources {
          ...resourceListFragment
          statistics {
            ...resourceListStatisticsFragment
          }
        }
        totalCount
      }
    }
    ${ResourceFragments.listFragment}
    ${ResourceStatisticsFragments.listFragment}
  `;

  static documentResourcesQuery = gql`
    query DocumentResources(
      $documentId: String
      $resourceId: String
      $contentId: String
      $inTemplate: Boolean
    ) {
      documentResources(
        documentId: $documentId
        resourceId: $resourceId
        contentId: $contentId
        inTemplate: $inTemplate
      ) {
        id
        resourceId
        contentId
        documentId
        inTemplate
      }
    }
  `;
}
